import React, { Component, lazy, Suspense } from 'react';
import {connect} from 'react-redux'
import { Redirect } from 'react-router-dom';
import { QrReader } from 'react-qr-reader';
import adapter from 'webrtc-adapter';

import {
  Badge,
  Button,
  ButtonDropdown,
  ButtonGroup,
  ButtonToolbar,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Progress,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label
} from 'reactstrap';
import { AddFileAttempt_ACTION, AddObjectAttempt_ACTION, GetListAttempt_ACTION, GetListDataPoolAttempt_ACTION, GetListObjectAttemptPost_ACTION } from '../../Actions/LogisticActions';
import KeyboardQuestionPlayComponent from '../../Components/KeyboardQuestionPlayComponent';
import NameComponent from '../../Components/NameComponent';
import PlayGeneralMap from '../../Components/PlayGeneralMap';
import SearchCoursesComponent from '../../Components/SearchCoursesComponent';
import SearchingTitleComponent from '../../Components/SearchingTitleComponent';
import TextInputComponent from '../../Components/TextInputComponent';
import { Routes } from '../../Services/API';
import { CreateChuck, responsiveFontSize, responsiveHeight, responsiveWidth, WEBSITE_URL } from '../../Services/Utilities';
import MathJax from 'react-mathjax'
import AdvancedLatexComponent from '../../Components/AdvancedLatexComponent';
import LineComponent from '../../Components/LineComponent';
import PlayStatisticsDrawingComponent from '../../CanvasDrawing/PlayStatisticsDrawingComponent';
import {DatePicker} from 'reactstrap-date-picker'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import QRCode from "react-qr-code";
import { ChangePlayerKey_ACTION } from '../../Actions/AuthorizationActions';
import { resetWarningCache } from 'prop-types';
import DateTimePicker from 'react-datetime-picker';
import PlayerSpecificDashboard from '../../Components/PlayerSpecificDashboard';
var LogoImage = require('../../Sources/Heat_quiz_logo.png')

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.First_Block_Ref = React.createRef()

 
    this.state = {
      DPDropDownOpen: false,
      SelectedDP:{NickName:'-', Topics:[]},
      SelectedTopics:[],
      receiver_key:"",
      ShowQRCodeScan: false,
      First_Block_Width: responsiveWidth(24),
      First_Block_Visible: false
    };

    this.renderStatistics = this.renderStatistics.bind(this)
    this.ShareKeyModal = this.ShareKeyModal.bind(this)
    this.ReveiveKeyModal = this.ReveiveKeyModal.bind(this)
  }

  componentDidMount(){

  }


  render() {
   console.log(this)

    return (
      <div className="animated fadeIn">
        {this.ShareKeyModal()}
        {this.ReveiveKeyModal()}
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
             
              <div className = "square border">
              {this.props.StudentKey ? 
              <div style = {{margin: responsiveFontSize(0.5), flexDirection:'row', display:'flex'}}>
                <div style = {{marginRight: responsiveWidth(0.5), flexDirection:'row', display:'flex'}}>
                <h1
                style = {{fontSize: responsiveFontSize(1.5)}}
                >👨‍🎓</h1>
                <h4 style = {{color:'#0099cc', fontSize: responsiveFontSize(1), marginLeft: responsiveWidth(0.5)}}>{this.props.StudentKey}</h4>

                </div>
                <div
                style = {{flexDirection:'column', display:'flex', alignItems:'center', alignContent:'center'}}>
                  <QRCode
                      size={256}
                      style={{ height: responsiveWidth(6), width: responsiveWidth(6)}}
                      value={this.props.StudentKey}
                      viewBox={`0 0 256 256`}
                      imageSettings={{src:LogoImage, excavate:true}}
                      />
                </div>
                <div>
                <div style = {{marginLeft: responsiveWidth(1)}}>
                        <div className="square border" style = {{cursor:'pointer'}} onClick = {() => {
                                return
                                this.setState({
                                  ShowShareKeyModal: true, 
                                  receiver_key: ''
                                })
                        }}>
                          <h6 style = {{
                            fontSize: responsiveFontSize(0.8),
                            margin: responsiveWidth(0.25), textAlign:'left', color:'#0099cc'}}>
                          📤 Share Key</h6>
                        </div>
                        <div className="square border" style = {{marginTop: responsiveWidth(0.5), cursor:'pointer'}} onClick = {() => {
                            return
                            this.props.GetSharedKeys(this.props.StudentKey)

                            this.setState({
                              ShowReveiveKeyModal: true
                            })
                        }}>
                          <h6 style = {{
                            fontSize: responsiveFontSize(0.8),
                            margin:responsiveWidth(0.25), textAlign:'left', color:'#0099cc'}}>
                          📥 Receive Key</h6>
                        </div>
                      </div>
                </div>
                
              </div>
              :<div/>}
              <hr/>
              <PlayerSpecificDashboard NotEditable/>
              </div>

              {this.props.roles.includes("student")?<div/> : <hr/>}
              {this.props.roles.includes("student") ?<div/> :
              <Row style = {{width:'95%', marginLeft:'2%'}}>   
                <Col xs = {2}>
                  <h5>
                    <Badge color = "primary" style = {{cursor:'pointer'}} onClick = {() => {
                      this.props.GetQuestionsStatistics_7DAY()
                    }}>
                      Load 7-Day statistics
                    </Badge>
                  </h5>
                </Col>
                <Col xs = {10}>
                {(this.props.IsQuestionStatisticsSearching_7DAY || this.props.GetQuestionStatisticsError_7DAY)? 
                                <SearchingTitleComponent  error = {this.props.GetQuestionStatisticsError_7DAY}/>
                : 
                <div>
                  <div>
                    <h6>Questions</h6>
                  </div>
                  <div   style = {{flexDirection:'row', display:'flex'}}>
                {(this.props.QuestionStatistics_7DAY ? this.props.QuestionStatistics_7DAY.RWeek:[]).reverse().map((w, wi) => (
                  <div style = {{width:'100%'}} key = {wi}>
                    <p className="text-muted">{w.Date}</p>

                     <p
                   style = {{color:'#0099cc', fontWeight:'bold', marginRight:10}}
                   >{w.Total}</p>
                  </div>
                 ))}
                 </div>

                 <div>
                  <hr/>
                    
                    <h6> Total active players last week<strong
                    style = {{color:'#0099cc', marginLeft: responsiveWidth(1)}}
                    >{this.props.QuestionStatistics_7DAY ? this.props.QuestionStatistics_7DAY.NPlayers: ''}</strong></h6>
                     </div>
                  <hr/>
                     <div>
                                        <h6>PDF views</h6>

                  </div>
                  <div   style = {{flexDirection:'row', display:'flex'}}>
                {(this.props.QuestionStatistics_7DAY ? this.props.QuestionStatistics_7DAY.PDFWeek:[]).reverse().map((w, wi) => (
                  <div style = {{width:'100%'}} key = {wi}>
                    <p className="text-muted">{w.Date}</p>

                     <p
                   style = {{color:'#0099cc', fontWeight:'bold', marginRight:10}}
                   >{w.Total}</p>
                  </div>
                 ))}
                 </div>
                 </div>}
                </Col>
              </Row>}
  </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  renderStatistics(){
    let First_Block_Width = this.state.First_Block_Width
    return(
      <div style = {{marginBottom: responsiveHeight(2)}}>
         <Row style = {{width:'95%', marginLeft:'2%', marginTop:responsiveWidth(0.5)}}>
         <h4 className="fw-normal" style = {{fontSize: responsiveFontSize(1)}}>Player Statistics</h4>
              
              </Row>
              <Row style = {{width:'95%', marginLeft:'2%', marginTop:responsiveWidth(0.5)}}>
                  <Col xs = {3} style = {{backgroundColor:'#D3DAE3', borderRadius:responsiveWidth(0.5), alignContent:'flex-start', alignItems:'flex-start', display:'flex', flexDirection:'column', width:'100%'}}>
                        
                        <div
                        ref = {this.First_Block_Ref}
                        style = {{
                          opacity: this.state.First_Block_Visible ? '100%' : '0%',
                          width:'100%',flexDirection:'row', display:'flex', alignItems:'center', alignContent:'space-between'}}>
                          <div style = {{width:First_Block_Width*0.25, backgroundColor:'white', marginRight:First_Block_Width*0.05, borderRadius:responsiveWidth(0.35), marginTop:responsiveWidth(0.5), marginBottom:responsiveWidth(0.5)}}>
                            <h5 style = {{margin:responsiveFontSize(0.25), textAlign:'center', fontSize: responsiveFontSize(1)}}>Course:</h5>
                          </div>
                          <div style = {{marginRight:First_Block_Width*0.05, borderRadius:responsiveWidth(0.35), marginTop:responsiveWidth(0.5), marginBottom:responsiveWidth(0.5), cursor:'pointer'}}>
                          <Dropdown isOpen={this.state.DPDropDownOpen} toggle={() => {
                            this.setState(prev => ({
                              DPDropDownOpen: !this.state.DPDropDownOpen
                            }))
                          }}>
                            <DropdownToggle caret
                            style = {{backgroundColor:'white',
                            fontSize: responsiveFontSize(0.8), width: First_Block_Width*0.60,
                            textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap'}}
                            onClick={() => {
                              this.setState(prev => ({
                                DPDropDownOpen: !this.state.DPDropDownOpen
                              }))
                            }}
                            >
                              {this.state.SelectedDP.NickName}
                            </DropdownToggle>
                            <DropdownMenu>
                              {(this.props.DPs ||[]).map((d,i) => (
                                <DropdownItem style = {{ backgroundColor:'white'}} key = {i} onClick={() => {
                                  this.setState(prev => ({
                                    SelectedDP:d,
                                    SelectedTopics:[],
                                    DPDropDownOpen: !prev.DPDropDownOpen
                                  }))
                                }}>{d.NickName}</DropdownItem >
                                
                              ))}
                            </DropdownMenu>
                          </Dropdown>
                          </div>
                          <div style = {{width:First_Block_Width*0.15, backgroundColor:'white', borderRadius:responsiveWidth(0.35), marginTop:responsiveWidth(0.5), marginBottom:responsiveWidth(0.5), cursor:'pointer'}}
                          onClick = {() => {
                            let VM = ({
                              query_dp_Id: this.state.SelectedDP.Id,
                              Player: this.props.StudentKey,
                              TopicIds: this.state.SelectedTopics
                            })

                            this.props.GetAdvancedDataPoolStatistics(VM)
                          }}
                          >
                            <h5 style = {{margin:responsiveFontSize(0.25), textAlign:'center', color:'green', fontWeight:'bolder', fontSize: responsiveFontSize(1.0)}}>➜</h5>
                          </div>
                        
                        </div>
                    <div style = {{
                      width:'100%',
                      backgroundColor:'white',
                      flexDirection:'row', display:'flex', alignItems:'flex-start', alignContent:'flex-start', borderRadius: responsiveFontSize(0)}}>
                         <FormGroup style ={{margin: responsiveFontSize(0.25),
                           flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center'}}>
                            <Label style = {{fontSize: responsiveFontSize(0.8), width: responsiveWidth(5)}}>From</Label>
                            <DatePicker 
                                        value   = {this.state.FromDate} 
                                        onChange= {(v,f) => {
                                          this.setState({
                                            FromDate: v,
                                            FromDateFormat: f
                                          })
                                        }} 
                                        style = {{fontSize: responsiveFontSize(0.8)}}
                                        />
                          </FormGroup>

                    </div>
                    <div style = {{
                      width:'100%',
                      backgroundColor:'white',
                      flexDirection:'row', display:'flex', alignItems:'flex-start', alignContent:'flex-start', borderRadius: responsiveFontSize(0)}}>
                         <FormGroup style ={{margin: responsiveFontSize(0.25),
                           flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center'}}>
                            <Label style = {{fontSize: responsiveFontSize(0.8), width: responsiveWidth(5)}}>To</Label>
                            <DatePicker 
                                        value   = {this.state.ToDate} 
                                        onChange= {(v,f) => {
                                          this.setState({
                                            ToDate: v,
                                            ToDateFormat: f
                                          })
                                        }} 
                                        style = {{fontSize: responsiveFontSize(0.8)}}
                                        />
                          </FormGroup>

                    </div>
                    <div 
                    
                    style = {{width:'100%',display:'flex', flexDirection:'row',
                     borderBottom:1, borderBottomColor:'#cccccc',
                     width:'100%', backgroundColor:'white',
                      marginTop:responsiveWidth(0.1), borderRadiusTop:responsiveWidth(0.35)}}>

                      <div style = {{width: First_Block_Width*0.5}}>
                          <h5 style = {{ textAlign:'left',width:'100%', marginLeft:responsiveWidth(0.5), fontSize: responsiveFontSize(1.0)}}>Topics</h5>
                      </div>
                      <div style = {{width: First_Block_Width*0.25,opacity: this.state.SelectedTopics.length ? '100%' : '50%', marginRight: First_Block_Width*0.05}}>
                        <h5 style = {{ textAlign:'left', width:'100%', fontSize:responsiveFontSize(0.8)}}>
                              <Badge color = "secondary" style = {{cursor:'pointer'}} onClick = {() => {
                                this.setState({
                                  SelectedTopics:[]
                                })
                              }}>
                                clear selection
                              </Badge>
                            </h5>
                      </div>
                      <div style = {{width: First_Block_Width*0.2,}}>
                        <h5 style = {{ textAlign:'left', width:'100%', fontSize:responsiveFontSize(0.8)}}>
                            <Badge color = "primary" style = {{cursor:'pointer'}} onClick = {() => {
                              this.setState({
                                SelectedTopics:this.state.SelectedDP.Topics.map((t,ti) => t.Id)
                              })
                            }}>
                              select all
                            </Badge>
                          </h5>
                      </div>
                      </div>
                      <div style = {{
                        backgroundColor:'white',
                        height:responsiveHeight(30), overflowY:'scroll',
                     flex:'display', flexDirection:'column',
                     alignItems:'center', alignContent:'center',
                     width:'100%', marginBottom:responsiveWidth(0.5),}}>
                        {this.state.SelectedDP.Topics.map((t,ti) => (
                          <div key = {ti}>
                            <Row style = {{ width:'98%', marginTop:responsiveWidth(0.5), cursor:'pointer',
                           marginLeft:responsiveWidth(0.25), borderBottom:1, borderBottomColor:'#e6e6e6'}} onClick = {() => {
                            let SelectedTopics = this.state.SelectedTopics

                            if(this.state.SelectedTopics.includes(t.Id)){
                              SelectedTopics = SelectedTopics.filter((a) => a != t.Id)
                            }
                            else{
                              SelectedTopics.push(t.Id)
                            }

                            this.setState({
                              SelectedTopics: SelectedTopics
                            })

                          }}>
                            <Col xs = {2} >
                              <h6 
                              style={{fontSize: responsiveFontSize(0.7), width:'100%'}}
                              className={this.state.SelectedTopics.includes(t.Id) ? "text-primary" : "text-secondary"}>{ti+1}</h6>
                            </Col>
                            <Col xs = {9} >
                              <h6 style = {{textAlign:'left', fontSize: responsiveFontSize(0.7)}} className={this.state.SelectedTopics.includes(t.Id) ? "text-primary" : "text-muted"}>{t.Name}</h6>
                            </Col>
                          </Row>
                          {(this.props.DPStats && this.props.DPStats.StatisticsByTopic
                          && ((t.Id+"") in this.props.DPStats.StatisticsByTopic)) ? 
                          <div>
                            <h6 style = {{textAlign:'center', fontSize: responsiveFontSize(0.7)}}>
                              ({this.props.DPStats.StatisticsByTopic[t.Id+""].TotalPlayCorrect}/{this.props.DPStats.StatisticsByTopic[t.Id+""].TotalPlay},  {(100 * this.props.DPStats.StatisticsByTopic[t.Id+""].TotalPlayCorrect/this.props.DPStats.StatisticsByTopic[t.Id+""].TotalPlay).toFixed(2)}%)
                              </h6>
                          </div> : <div/>
                          }
                          </div>
                        ))}
                    </div>
                  </Col>
                  <Col xs = {3} style = {{backgroundColor:'#D3DAE3', marginLeft:10, borderRadius:10, alignContent:'center', alignItems:'center', display:'flex', flexDirection:'column'}}>
                          <Row style = {{flexDirection:'column', flex:'display',
                          alignContent:'center', alignItems:'center',
                           margin: responsiveWidth(0.5),
                           width:'100%', borderRadius:responsiveWidth(0.35), backgroundColor:'white'}}> 
                            <Row style = {{width:'100%'}}>
                              <Col xs = {12}>
                                  <h5 style = {{textAlign:'center', color:'#0099cc', fontSize: responsiveFontSize(1)}}>
                                    Time Played
                                  </h5>
                              </Col>
                             
                            </Row>
                            <Row style = {{width:'100%', backgroundColor:'#e6e6e6'}}>
                              <Col xs = {12} style = {{width:'100%', flexDirection:'column', flex:'display'}}>
                                  <h5 style = {{textAlign:'center', fontSize: responsiveFontSize(1)}}>
                                    {(this.props.DPStats && this.props.DPStats.TotalTimePlayed) ? 
                                    (new Date(this.props.DPStats.TotalTimePlayed  * 1000).toISOString().slice(11, 19)):'-'}
                                  </h5>
                                  <p style = {{textAlign:'center', fontSize: responsiveFontSize(0.7)}} className="text-muted">
                                  hh:mm:ss
                                  </p>
                              </Col>
                             
                            </Row>
                          </Row>

                          <Row style = {{flexDirection:'column', flex:'display',
                          alignContent:'center', alignItems:'center',
                           margin: responsiveWidth(0.25),
                           width:'100%', borderRadius: responsiveWidth(0.35), backgroundColor:'white'}}> 
                            <Row style = {{width:'100%', marginTop: responsiveWidth(0.25),}}>
                            <Col xs = {12}>
                                  <h6 style = {{textAlign:'left', color:'#0099cc', fontSize: responsiveFontSize(0.8)}}>
                                    Games played
                                  </h6>
                              </Col>
                              <Col xs = {12}>
                                  <h1 style = {{textAlign:'left', color:'#0099cc', fontSize: responsiveFontSize(1.8)}}>
                                    {(this.props.DPStats && this.props.DPStats.TotalStatistics) ? 
                                     this.props.DPStats.TotalStatistics
                                     
                                     : '-'
                                  }
                                  </h1>
                              </Col>
                             
                            </Row>
                            <Row style = {{width:'100%', marginTop:responsiveWidth(0.5), marginleft:responsiveWidth(0.25)}}>
                            <Col xs = {12}>
                                  <h6 style = {{textAlign:'left', color:'green', fontSize: responsiveFontSize(0.8)}}>
                                  Correct Games played
                                  </h6>
                              </Col>
                              <Col xs = {12} >
                                  <div style = {{flexDirection:'row', display:'flex', alignItems:'flex-start'}}>
                                  <h1 style = {{textAlign:'left', color:'green', marginRight: responsiveWidth(1.25), fontSize: responsiveFontSize(1.8)}}>
                                    {(this.props.DPStats && this.props.DPStats.Correct) ? 
                                     this.props.DPStats.Correct
                                     
                                     : '-'
                                  }
                                  </h1>
                                 
                                  <h5 style = {{textAlign:'left', color:'green', fontSize: responsiveFontSize(0.9)}}>{(this.props.DPStats && this.props.DPStats.Correct && this.props.DPStats.TotalStatistics) ?
                                   ((this.props.DPStats.Correct/this.props.DPStats.TotalStatistics) * 100).toFixed(2) : ''
                                  }%</h5>
                                  </div>
                                  
                                 
                              </Col>
                              
                            </Row>
                          </Row>
                  </Col>
                  <Col xs = {5} style = {{backgroundColor:'#D3DAE3', marginLeft:responsiveWidth(0.5), borderRadius:responsiveWidth(0.35), alignContent:'center', alignItems:'center', display:'flex', flexDirection:'column'}}>
                    <Row style = {{flexDirection:'column', flex:'display',
                          alignContent:'center', alignItems:'center',
                           margin:responsiveWidth(0.5),
                           width:'100%', borderRadius:responsiveWidth(0.35), backgroundColor:'white'}}>
                      <h6 style = {{textAlign:'center', fontSize: responsiveFontSize(1)}}>
                        Average Games Played
                        </h6>
                      {this.renderGraph()}
                      {(!this.props.DPStats || !this.props.DPStats.avg_all_7_days) ?
                      <div/>: 
                      <p style = {{textAlign:'left',
                       fontSize: responsiveFontSize(0.75)}}>*Band is based on the average nr. of games played by the top 10% and the rest of the players.</p> 
                      }
                    </Row>
                  </Col>
              </Row>
      </div>
    )
  }

  
  ShareKeyModal(){
    if(!this.state.ShowShareKeyModal){
      return
    }

    return(
      <Modal isOpen = {this.state.ShowShareKeyModal} size = "lg">
        <ModalHeader toggle = {()=>{
            this.setState({
              ShowShareKeyModal: false
            })
        }}>
            Share Player Key  
            </ModalHeader> 
            <ModalBody>
              <div>
                <div className="border border-primary" style={{marginBottom: responsiveWidth(0.5)}}> 
                  <div style = {{margin: responsiveWidth(0.5)}}>
                    <h6 className="text text-primary">Key share steps:</h6>
                    <p>* Receiver must play at least One game to be visible in the system.</p>
                    <p>1- Enter the receivers key and then click "Share Key".</p>
                    <p>2- On the receiver's dashboard, click "Receive Key" and approve it.</p>
                    <p className = "square border-bottom border-danger" style = {{width:'35%', textAlign:'center'}}>Note: Key sharing expires in 5 minutes.</p>
                  </div>
                </div>
                <div>
                <div  className = "square border" style = {{
                  flexDirection:'row', display:'flex', alignItems:'center', alignContent:'space-between'}}>
                  <h6 style = {{width:'20%',textAlign:'center',
                   marginTop:responsiveWidth(0.5)}} className ="text text-muted">
                    Receiver's key
                  </h6>
                  <div style = {{width:'75%', marginTop:responsiveWidth(0.5)}}>
                    <TextInputComponent
                      UpdateValue = {(v) => {
                        this.setState({
                          receiver_key:v.target.value
                        })
                      }}

                      TextValue={this.state.receiver_key}
                    />
                  </div>
                  <div style = {{width:'40%',
                flexDirection:'column', display:'flex', alignContent:'center', alignItems:'center'}}>
                    
                    {!this.state.ShowQRCodeScan && false? 
                    <div className="square border" 
                    style = {{cursor:'pointer'}} onClick = {() => {
                            this.setState({
                              ShowQRCodeScan: true
                            })
                        }}>
                          <h6 
                          style = {{margin:responsiveWidth(0.25), textAlign:'center'}}>
                          Scan QR Code <i class="fa fa-qrcode" style = {{fontSize: responsiveFontSize(1)}}></i>
                          </h6>
                        </div> : <div/>}
                        {this.state.ShowQRCodeScan ?
                        <QrReader
                        onResult={(result, error) => {
                          if (!!result) {
                            //setData(result?.text);
                          }
                
                          if (!!error) {
                            console.info(error);
                          }
                        }}
                        style={{ width:  responsiveWidth(20), height: responsiveWidth(20) }}
                      /> : <div/>}
                  </div>
                </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
            <Button color="success" onClick = {() => {
                 if(!this.state.receiver_key.trim()){
                  alert("Please enter a value for the receiver's key")
                  return
                }

                this.props.AddShareKey(({
                  Sender: this.props.StudentKey, 
                  Receiver: this.state.receiver_key.trim()
                }), () => {
                  this.setState({
                    ShowShareKeyModal: false
                  })
                })
              }}>
                Share Key
              </Button>
              <Button color="danger" onClick = {() => {
                 this.setState({
                  ShowShareKeyModal: false
                })
              }}>
                Close
              </Button>
            </ModalFooter>
      </Modal>
    )
  }

  ReveiveKeyModal(){
    if(!this.state.ShowReveiveKeyModal){
      return
    }

    return(
      <Modal isOpen = {this.state.ShowReveiveKeyModal} size = "lg">
        <ModalHeader toggle = {()=>{
            this.setState({
              ShowReveiveKeyModal: false
            })
        }}>
            Receive Player Key  
            </ModalHeader> 
            <ModalBody>
              <div>
                <div>
                <h6 className ="text text-primary" style = {{textAlign:'left'}}>Received Keys</h6>
                </div>
                <div className="square border" style={{marginBottom: responsiveWidth(0.5)}}> 
                {(this.props.IsShareKeysSearching || this.props.IsShareKeysSearching == undefined || this.props.GetShareKeysError) ?
              <SearchingTitleComponent  error = {this.props.GetShareKeysError} OnError = {() => {}}/>
              : <div style = {{height: responsiveHeight(20), overflowY:'scroll'}}>
                  <Row style = {{marginBottom: responsiveWidth(0.5), width:'95%'}} >
                    <Col xs = {2}>
                    </Col>
                    <Col xs = {4}>
                      <h6>Sender</h6>
                    </Col>
                    <Col xs = {4}>
                      <h6>Receiver</h6>

                    </Col>
                    
                  </Row>
                  <hr/>
                  {(this.props.ShareKeys || []).map((sk, isk) =>(
                    <Row style = {{marginBottom: responsiveWidth(0.5), width:'95%'}}>
                    <Col xs = {1}>
                      <h6 className = "text-muted" style={{textAlign:'center'}}>{isk + 1}</h6>
                    </Col>
                    <Col xs = {5}>
                      <h6>{sk.Sender}</h6>
                    </Col>
                    <Col xs = {4}>
                      <h6  className = "text-muted">{sk.Receiver}</h6>

                    </Col>
                    <Col xs = {2}>
                      <h5>
                        <Badge color = "success" style = {{cursor:'pointer'}} onClick = {() => {
                            this.props.ApproveShareKey(({
                              Me: this.props.StudentKey,
                            }))

                            localStorage.setItem('student_key_ABCDEFG', sk.Sender) 
                            window.location.reload(false);

                        }}>
                          Select
                        </Badge>
                      </h5>
                    </Col>
                  </Row>
                ))}
                </div>}
                </div>
                
                </div>
            </ModalBody>
            <ModalFooter>
            
              <Button color="danger" onClick = {() => {
                 this.setState({
                  ShowReveiveKeyModal: false
                })
              }}>
                Close
              </Button>
            </ModalFooter>
      </Modal>
    )
  }
}

//
const COURSES_SEARCHING_PARAMETER = 'IsCoursesSearching'

const COURSES_DATA_PARAMETER = 'Courses'

const COURSES_GET_ERROR_PARAMETER = 'CoursesGetError'
//
const QUESTION_STATISTICS_SEARCHING_PARAMETER = 'IsSTATISTICSQuestionsSearching'

const QUESTION_STATISTICS_DATA_PARAMETER = 'STATISTICSQuestions'

const QUESTION_STATISTICS_GET_ERROR_PARAMETER = 'STATISTICSQuestionsGetError'

//
const QUESTION_STATISTICS_SEARCHING_PARAMETER_7DAY = 'QUESTION_STATISTICS_SEARCHING_PARAMETER_7DAY'
const QUESTION_STATISTICS_DATA_PARAMETER_7DAY = 'QUESTION_STATISTICS_DATA_PARAMETER_7DAY'
const QUESTION_STATISTICS_GET_ERROR_PARAMETER_7DAY = 'QUESTION_STATISTICS_GET_ERROR_PARAMETER_7DAY'

//
const QUESTION_STATISTICS_SEARCHING_PARAMETER_TOPIC = 'QUESTION_STATISTICS_SEARCHING_PARAMETER_TOPIC'
const QUESTION_STATISTICS_DATA_PARAMETER_TOPIC = 'QUESTION_STATISTICS_DATA_PARAMETER_TOPIC'
const QUESTION_STATISTICS_GET_ERROR_PARAMETER_TOPIC = 'QUESTION_STATISTICS_GET_ERROR_PARAMETER_TOPIC'
//
const STUDENT_STATISTICS_SEARCHING_PARAMETER = 'STUDENT_STATISTICS_SEARCHING_PARAMETER'
const STUDENT_STATISTICS_DATA_PARAMETER = 'STUDENT_STATISTICS_DATA_PARAMETER'
const STUDENT_STATISTICS_GET_ERROR_PARAMETER = 'STUDENT_STATISTICS_GET_ERROR_PARAMETER'

//Constant
const DP_TOPICS_SEARCHING_PARAMETER = 'IsDPTopicsSearching'
const DP_TOPICS_DATA_PARAMETER = 'DPsTopics'
const DP_TOPICS_GET_ERROR_PARAMETER = 'DPTopicsGetError'

const DP_STATS_SEARCHING_PARAMETER = 'IsDPStatsSearching'
const DP_STATS_DATA_PARAMETER = 'DPsStats'
const DP_STATS_GET_ERROR_PARAMETER = 'DPStatsGetError'

//Constant
const SHARE_KEYS_SEARCHING_PARAMETER = 'SHARE_KEYS_SEARCHING_PARAMETER'
const SHARE_KEYS_DATA_PARAMETER = 'SHARE_KEYS_DATA_PARAMETER'
const SHARE_KEYS_GET_ERROR_PARAMETER = 'SHARE_KEYS_GET_ERROR_PARAMETER'
const SHARE_KEYS_IS_ADDING_PARAMTER = 'SHARE_KEYS_IS_ADDING_PARAMTER'
const SHARE_KEYS_ADD_ERROR_PARAMETER = 'SHARE_KEYS_ADD_ERROR_PARAMETER'

function MapStateToProps(state) {
  console.log(state)
  return {
    IsStudent: state.Authorization.student,
    StudentKey: state.Authorization.student_key,
    roles: state.Authorization.roles,
    Courses:state.Query[COURSES_DATA_PARAMETER],
      IsSearching: state.Query[COURSES_SEARCHING_PARAMETER],
      GetError: state.Query[COURSES_GET_ERROR_PARAMETER],

      IsQuestionStatisticsSearching: state.Query[QUESTION_STATISTICS_SEARCHING_PARAMETER],
      QuestionStatistics: state.Query[QUESTION_STATISTICS_DATA_PARAMETER],
      GetQuestionStatisticsError: state.Query[QUESTION_STATISTICS_GET_ERROR_PARAMETER],

      IsQuestionStatisticsSearching_7DAY: state.Query[QUESTION_STATISTICS_SEARCHING_PARAMETER_7DAY],
      QuestionStatistics_7DAY: state.Query[QUESTION_STATISTICS_DATA_PARAMETER_7DAY],
      GetQuestionStatisticsError_7DAY: state.Query[QUESTION_STATISTICS_GET_ERROR_PARAMETER_7DAY],

      IsQuestionStatisticsSearching_TOPIC: state.Query[QUESTION_STATISTICS_SEARCHING_PARAMETER_TOPIC],
      QuestionStatistics_TOPIC: state.Query[QUESTION_STATISTICS_DATA_PARAMETER_TOPIC],
      GetQuestionStatisticsError_TOPIC: state.Query[QUESTION_STATISTICS_GET_ERROR_PARAMETER_TOPIC],

      IsStudentStatisticsSearching: state.Query[STUDENT_STATISTICS_SEARCHING_PARAMETER],
      StudentStatistics: state.Query[STUDENT_STATISTICS_DATA_PARAMETER],
      GetStudentStatisticsError: state.Query[STUDENT_STATISTICS_GET_ERROR_PARAMETER],

      DPs:state.Query[DP_TOPICS_DATA_PARAMETER],
      IsDPsSearching: state.Query[DP_TOPICS_SEARCHING_PARAMETER],
      GetDPsError: state.Query[DP_TOPICS_GET_ERROR_PARAMETER],

      DPStats:state.Query[DP_STATS_DATA_PARAMETER],
      IsDPStatsSearching: state.Query[DP_STATS_SEARCHING_PARAMETER],
      GetDPStatsError: state.Query[DP_STATS_GET_ERROR_PARAMETER],

      ShareKeys:state.Query[SHARE_KEYS_DATA_PARAMETER],
      IsShareKeysSearching: state.Query[SHARE_KEYS_SEARCHING_PARAMETER],
      IsShareKeysAdding: state.Query[SHARE_KEYS_IS_ADDING_PARAMTER],
      GetShareKeysError: state.Query[SHARE_KEYS_GET_ERROR_PARAMETER],
      AddShareKeysError: state.Query[SHARE_KEYS_ADD_ERROR_PARAMETER],
    }
}

const MapDispatchToProps = (dispatch) => {
  return {
      GetQuestionsStatistics: () => {dispatch(GetListAttempt_ACTION({
            SearchParameter: QUESTION_STATISTICS_SEARCHING_PARAMETER,
            DataParameter: QUESTION_STATISTICS_DATA_PARAMETER,
            GetErrorParameter: QUESTION_STATISTICS_GET_ERROR_PARAMETER,
            Path: Routes.GetQuestionsStatistics,
            [QUESTION_STATISTICS_SEARCHING_PARAMETER]: true,
            
            [QUESTION_STATISTICS_DATA_PARAMETER]: [],
    
            [QUESTION_STATISTICS_GET_ERROR_PARAMETER]: ''
        }))},

        GetStudentStatistics: (Player) => {dispatch(GetListAttempt_ACTION({
          SearchParameter: STUDENT_STATISTICS_SEARCHING_PARAMETER,
          DataParameter: STUDENT_STATISTICS_DATA_PARAMETER,
          GetErrorParameter: STUDENT_STATISTICS_GET_ERROR_PARAMETER,

          Path: Routes.GetStudentStatistics,
          Value:Player,
          [STUDENT_STATISTICS_SEARCHING_PARAMETER]: true,
          
          [STUDENT_STATISTICS_DATA_PARAMETER]: [],
  
          [STUDENT_STATISTICS_GET_ERROR_PARAMETER]: ''
      }))},

        GetQuestionsStatistics_7DAY: () => {dispatch(GetListAttempt_ACTION({
          SearchParameter: QUESTION_STATISTICS_SEARCHING_PARAMETER_7DAY,
          DataParameter: QUESTION_STATISTICS_DATA_PARAMETER_7DAY,
          GetErrorParameter: QUESTION_STATISTICS_GET_ERROR_PARAMETER_7DAY,
          Path: Routes.Get7DayStatistics,
          [QUESTION_STATISTICS_SEARCHING_PARAMETER_7DAY]: true,
          
          [QUESTION_STATISTICS_DATA_PARAMETER_7DAY]: [],
  
          [QUESTION_STATISTICS_GET_ERROR_PARAMETER_7DAY]: ''
      }))},

      GetQuestionsStatistics_TOPIC: () => {dispatch(GetListAttempt_ACTION({
        SearchParameter: QUESTION_STATISTICS_SEARCHING_PARAMETER_TOPIC,
        DataParameter: QUESTION_STATISTICS_DATA_PARAMETER_TOPIC,
        GetErrorParameter: QUESTION_STATISTICS_GET_ERROR_PARAMETER_TOPIC,
        Path: Routes.GetTopicStatistics,
        [QUESTION_STATISTICS_SEARCHING_PARAMETER_TOPIC]: true,
        
        [QUESTION_STATISTICS_DATA_PARAMETER_TOPIC]: [],

        [QUESTION_STATISTICS_GET_ERROR_PARAMETER_TOPIC]: ''
    }))},
    GetDataPoolTopics: (Player) => {dispatch(GetListDataPoolAttempt_ACTION({
      SearchParameter: DP_TOPICS_SEARCHING_PARAMETER,
      DataParameter: DP_TOPICS_DATA_PARAMETER,
      GetErrorParameter: DP_TOPICS_GET_ERROR_PARAMETER,

      Path: Routes.GetDataPoolTopics,
      Value: Player,
      [DP_TOPICS_SEARCHING_PARAMETER]: true,
      [DP_TOPICS_DATA_PARAMETER]: [],
      [DP_TOPICS_GET_ERROR_PARAMETER]: '',
  }))},
  GetAdvancedDataPoolStatistics: (Data) => {dispatch(GetListObjectAttemptPost_ACTION({
    SearchParameter: DP_STATS_SEARCHING_PARAMETER,
    DataParameter: DP_STATS_DATA_PARAMETER,
    GetErrorParameter: DP_STATS_GET_ERROR_PARAMETER,

    Path: Routes.AdvancedDataPoolStatistics,

    Body: Data,

    [DP_STATS_SEARCHING_PARAMETER]: true,
    [DP_STATS_DATA_PARAMETER]: [],
    [DP_STATS_GET_ERROR_PARAMETER]: '',
}))},

  GetSharedKeys: (Value) => {dispatch(GetListAttempt_ACTION({
    SearchParameter: SHARE_KEYS_SEARCHING_PARAMETER,
    DataParameter: SHARE_KEYS_DATA_PARAMETER,
    GetErrorParameter: SHARE_KEYS_GET_ERROR_PARAMETER,

    Path: Routes.ShareKeyGetMyKeys,
    Value:Value,
    [SHARE_KEYS_SEARCHING_PARAMETER]: true,
    
    [SHARE_KEYS_DATA_PARAMETER]: [],

    [SHARE_KEYS_GET_ERROR_PARAMETER]: ''
  }))},
  AddShareKey: (Data, OnSuccess) => {dispatch(AddObjectAttempt_ACTION({
    AddParameter:SHARE_KEYS_IS_ADDING_PARAMTER,
    AddErrorParameter:SHARE_KEYS_ADD_ERROR_PARAMETER,

    AddPath: Routes.ShareKeyAdd,
    
    [SHARE_KEYS_IS_ADDING_PARAMTER]: true,
    [SHARE_KEYS_ADD_ERROR_PARAMETER]: '',
    Body:Data,
    OnSuccess:OnSuccess
}))},
  ApproveShareKey: (Data, OnSuccess) => {dispatch(AddObjectAttempt_ACTION({
    AddPath: Routes.ShareKeyApproveKey,
    Body:Data,
    OnSuccess:OnSuccess
}))}
  }
}

export default connect(MapStateToProps, MapDispatchToProps)(Dashboard)
